module.exports = JSON.parse('{"Export":"Exportar","Create Report":"Criar relatório"}')